import { create } from 'zustand'
import { readToken, writeToken } from '@/api/client'

/**
 * Port of the Vuex `auth` module. The token lives in localStorage exactly as
 * before; the store keeps it in sync so components re-render on sign-in and
 * sign-out (the original derived `is_authenticated` from a separate piece of
 * state that could drift from the token).
 */
interface AuthState {
  token: string | null
  isAuthenticated: boolean
  setToken: (token: string) => void
  clear: () => void
}

export const useAuthStore = create<AuthState>((set) => ({
  token: readToken(),
  isAuthenticated: readToken() !== null,

  setToken: (token) => {
    writeToken(token)
    set({ token, isAuthenticated: true })
  },

  clear: () => {
    writeToken(null)
    set({ token: null, isAuthenticated: false })
  },
}))

export const selectIsAuthenticated = (state: AuthState) => state.isAuthenticated
